(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDashboardOutputDialogController', GrievanceDashboardOutputDialogController);

    GrievanceDashboardOutputDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GrievanceDashboardOutput'];

    function GrievanceDashboardOutputDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GrievanceDashboardOutput) {
        var vm = this;

        vm.grievanceDashboardOutput = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.grievanceDashboardOutput.id !== null) {
                GrievanceDashboardOutput.update(vm.grievanceDashboardOutput, onSaveSuccess, onSaveError);
            } else {
                GrievanceDashboardOutput.save(vm.grievanceDashboardOutput, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:grievanceDashboardOutputUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
